import { useAuth } from "@/stores/authStore";

// Conditionally renders children when the user has the permission.
export function PermissionGate({ perm, children, fallback = null }) {
  const { hasPermission } = useAuth();
  return hasPermission(perm) ? children : fallback;
}
